import React, { memo } from 'react'
import CountUpAnimation from 'react-countup'

import { getNonNegativeNumber } from '../../../util/brand.helpers'
import { formatTicks } from '../../../util/string.helpers'

const BalanceCountDown = ({ prev, current }) => {
  return (
    <CountUpAnimation
      start={prev}
      end={getNonNegativeNumber(current)}
      duration={2}
      formattingFn={formatTicks}
    />
  )
}

export default memo(BalanceCountDown)
